module.exports = __webpack_public_path__ + "img/Vector7.db203f38.svg";